import {raise} from './events'

const EXPECTED_WIDTH = 2048

let scaleFactor = window.innerWidth / EXPECTED_WIDTH

export const PROPORTIONAL = {}

export function getScaleFactor() {
    return scaleFactor
}

window.addEventListener('resize', () => {
    scaleFactor = window.innerWidth / EXPECTED_WIDTH
    raise('resize')
})

export function proportional(input = PROPORTIONAL, scale) {
    if (typeof input === 'object') {
        let result = input
        for (let key in input) {
            input[key] = input[key] * scaleFactor
        }
        if (scale === true) {
            result.scaleX = scaleFactor
            result.scaleY = scaleFactor
        }
        if(typeof scale === 'number') {
            result.scaleX = scaleFactor * scale
            result.scaleY = scaleFactor * scale
        }
        return result
    } else {
        if(scale) {
            return +input * (1/scaleFactor)
        }
        return +input * scaleFactor
    }
}
